import { render } from "./COVIDSafetyNoticeLayout.vue?vue&type=template&id=1e6484bc&scoped=true&ts=true"
import script from "./COVIDSafetyNoticeLayout.vue?vue&type=script&lang=ts&nonce=nonce-12345"
export * from "./COVIDSafetyNoticeLayout.vue?vue&type=script&lang=ts&nonce=nonce-12345"

import "./COVIDSafetyNoticeLayout.vue?vue&type=style&index=0&id=1e6484bc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6484bc"]])

export default __exports__